export default {
  apiKey: '3577c7bf7dsa7232dsadsd123-670f2eb21c4__',

  /**
   * Production
   *
   */
  apiUri: 'https://api.cmsriver.com/api/v1/',
  apiHost: 'https://api.cmsriver.com',
  appUri: 'https://app.cmsriver.com/',
  frontEnd: 'https://cmsriver.com/',
  authRedirectUri: 'https://app.cmsriver.com/auth/redirect',
  appPath: '/',

  /**
   * Development
   *
   */
  // apiUri: 'https://staging-v2.icel.or.id/api/v1/',
  // apiHost: 'https://staging-v2.icel.or.id',
  // appUri: 'https://staging-v2.icel.or.id/admin/',
  // frontEnd: 'https://staging-v2.icel.or.id/',
  // authRedirectUri: 'https://app.cmsriver.com/auth/redirect',
  // appPath: '/admin/',

  /**
   * Localhost
   *
   */
  // apiUri: 'http://localhost:5205/api/v1/',
  // apiHost: 'http://localhost:5205',
  // appUri: 'http://localhost:8080/admin/',
  // frontEnd: 'http://localhost:8080/',
  // authRedirectUri: 'http://localhost:8080/auth/redirect',
  // appPath: '/',

  authUri: 'https://account.dddtl.net/v2/oauth/authorize',
  authClientId: 'app',
  // authLogoutUri: 'http://localhost:8080/signout',
  authLogoutUri: 'https://account.dddtl.net/signout',

  appId: 'cmsriver',
  copyright: 'CMSRiver',
  uri(uri: string) {
    return `${this.apiUri}${uri}`;
  },
  key: 'oKofrAXf5bqzUoeAUebHFMAsDjsknX91',
};
